import Modal from '@/components/ui/modal/Modal';
import FunnelModalContent from '@/components/ui/modal/funnel/FunnelModalContent';
import FunnelModalTitle from '@/components/ui/modal/funnel/FunnelModalTitle';
import Button from '@/components/ui/Button';

interface HelperDialogProps {
  isOpen: boolean;
  isSafetyConcern?: boolean;
  title: string;
  safetyConcernTitleClass?: string;
  description: string;
  buttonText: string;
  onClose: () => void;
}

const SAFETY_CONCERN_INFO = {
  title: 'Based on your response, you are ineligible to complete your assessment.',
  description: `
    Please see your physician or call us if you have any questions.
    <div class="pt-[19px] tablet:pt-[20px]">
      Customer Care: <a href="tel:+18555819620" class="text-silver no-underline font-[700]">+1 (855) 581-9620</a>
    </div>
  `,
};

const HelperDialog: React.FC<HelperDialogProps> = ({
  isOpen,
  isSafetyConcern = false,
  title,
  safetyConcernTitleClass,
  description,
  buttonText,
  onClose,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={
        <FunnelModalTitle
          title={isSafetyConcern ? SAFETY_CONCERN_INFO.title : title}
          titleClass={safetyConcernTitleClass}
        />
      }
      buttons={
        <Button
          type="button"
          bgcolor="bg-funnel-bg hover:bg-funnel-bg"
          textcolor="text-ashgray"
          onClick={onClose}
          rounded="rounded-[46px] tablet:rounded-[16px]"
          className="border border-off-white !text-ashgray hover:!borer-[var(--color-gray)] !text-body-md tablet:!text-body !h-[43px] !normal-case !font-normal tablet:!h-[65px] shadow-off-white-shad"
          size="small"
        >
          {buttonText}
        </Button>
      }
    >
      <FunnelModalContent
        html={`<span class="text-silver text-body-md tablet:text-body inline-block">${isSafetyConcern ? SAFETY_CONCERN_INFO.description : description}</span>`}
      />
    </Modal>
  );
};

export default HelperDialog;
